import { useMemo } from "react";
import { useWorkflowsPaths } from "@/react/helpers/urlHelpers/internalApi/useWorkflowsPaths";
import { createWorkflowsApi } from "./workflowsApi";

export const useWorkflowsApi = () => {
  const workflowsPaths = useWorkflowsPaths();
  return useMemo(() => createWorkflowsApi(workflowsPaths), [workflowsPaths]);
};
